import clsx from 'clsx';
import type { MouseEvent, RefObject } from 'react';
import { style } from './icon.module.css';

interface Props {
  icon: string;
  iconRef?: RefObject<HTMLDivElement | null>;
  className?: string;
  variant?: 'outlined' | 'round';
  onClick?: (event?: MouseEvent<HTMLDivElement>) => void;
}

export function Icon(props: Props) {

  const { 
    icon,
    iconRef,
    className,
    variant = 'outlined',
    onClick
  } = props;

  return (
    <div
      ref={iconRef}
      className={clsx(
        style.icon, 
        className,
        variant === 'outlined' && 'material-icons-outlined',
        variant === 'round' && 'material-icons-round'
      )}
      onClick={onClick}>
      {icon}
    </div>
  );
}
